import React from "react";
import { useI18n } from "@/i18n";

export function Marquee() {
  const { t } = useI18n();
  const text = t.marquee;
  return (
    <div className="bg-midnight py-6 overflow-hidden border-y border-white/10" data-testid="marquee">
      <div className="marquee-track">
        <span className="font-serif italic text-champagne/80 text-2xl md:text-3xl pr-4">{text.repeat(4)}</span>
        <span className="font-serif italic text-champagne/80 text-2xl md:text-3xl pr-4">{text.repeat(4)}</span>
      </div>
    </div>
  );
}
